import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { Archived } from "../../../../model/filters/archived";
import { Router } from "@angular/router";

@Component({
  selector: "archived-form",
  templateUrl: "./archived-form.component.html",
  styleUrls: ["./archived-form.component.css"],
})
export class ArchivedFormComponent {
  @Input() filter: Archived = new Archived();
  @Output() applyFilter = new EventEmitter<Archived>();

  formVisible: boolean = true;

  constructor(private router: Router) {}

  apply(): void {
    const filter: Archived = new Archived();

    this.applyFilter.emit(filter);
    this.formVisible = false;
  }
}
